import React from "react";
import ProductPageRedesign from "../redesign/ProductPageRedesign";
import { DifferntiatedProdDevItems } from "./DifferntiatedProdDevItems";

const DifferntiatedProdDev = () => {
  return (
    <ProductPageRedesign
      title="Differentiated Product Development"
      description="DelNova is a fully integrated biopharmaceutical company with capabilities to develop and manufacture small and large molecules, offering next-generation drug delivery technologies, affordable and clinically proven products."
      items={DifferntiatedProdDevItems}
      bannerImage="https://images.unsplash.com/photo-1579684389782-64d84b5e901a?q=80&w=1920&auto=format&fit=crop"
    />
  );
};

export default DifferntiatedProdDev;
